import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";

// CSS
import "./Header.scss";

// Helper
import { getCurrentUser, clearSession } from "../../Helper/Api";

class Header extends Component {
  state = {
    currentUser: getCurrentUser(),
    mobileOpen: false,
  };

  logout = (e) => {
    e.preventDefault();
    clearSession();
    window.location.href = "/";
  };

  toggleMobile = () => {
    this.setState((s) => ({ mobileOpen: !s.mobileOpen }));
  };

  closeMobile = () => {
    this.setState({ mobileOpen: false });
  };

  render() {
    const { tenant } = this.props;
    const { currentUser, mobileOpen } = this.state;
    const teacherName = (tenant && tenant.name) || "";

    return (
      <header className="site-header">
        <div className="nav-inner">
          <Link to="/" className="brand" onClick={this.closeMobile}>
            {tenant && tenant.image ? (
              <img className="logo-header" src={tenant.image} alt={teacherName} />
            ) : (
              <span className="brand-name">{teacherName}</span>
            )}
          </Link>

          <nav className="pages">
            <NavLink exact activeClassName="active" to="/">Home</NavLink>
            <NavLink activeClassName="active" to="/courses">Courses</NavLink>
            <NavLink activeClassName="active" to="/gallery">Gallery</NavLink>
            <NavLink activeClassName="active" to="/about">About</NavLink>
            <NavLink activeClassName="active" to="/contact">Contact</NavLink>
          </nav>

          <div className="nav-right">
            <a className="download-link" href="/downloads/Arch-Ahmed-Amer-Setup.exe" download>Download Desktop App</a>
            {currentUser ? (
              <div className="user-box">
                <span className="hi">Hi, {currentUser.fullName}</span>
                <button className="login-btn" onClick={this.logout}>Logout</button>
              </div>
            ) : (
              <Link className="login-btn" to="/sign-in">Login / Register</Link>
            )}
            <button
              className={`nav-toggle ${mobileOpen ? "open" : ""}`}
              aria-label="Open menu"
              aria-expanded={mobileOpen}
              onClick={this.toggleMobile}
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>
          </div>
        </div>

        <div className={`mobile-menu ${mobileOpen ? "open" : ""}`}>
          <NavLink exact activeClassName="active" to="/" onClick={this.closeMobile}>Home</NavLink>
          <NavLink activeClassName="active" to="/courses" onClick={this.closeMobile}>Courses</NavLink>
          <NavLink activeClassName="active" to="/gallery" onClick={this.closeMobile}>Gallery</NavLink>
          <NavLink activeClassName="active" to="/about" onClick={this.closeMobile}>About</NavLink>
          <NavLink activeClassName="active" to="/contact" onClick={this.closeMobile}>Contact</NavLink>
          <a href="/downloads/Arch-Ahmed-Amer-Setup.exe" download>Download Desktop App</a>
          {currentUser ? (
            <button className="mm-auth" onClick={this.logout}>Logout</button>
          ) : (
            <Link className="mm-auth" to="/sign-in" onClick={this.closeMobile}>Login / Register</Link>
          )}
        </div>
      </header>
    );
  }
}

export default Header;
